"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("standalone.error");

  useEffect(() => {
    import("@/lib/datadog-rum").then(({ addError }) => {
      addError(error, { source: "error-boundary" });
    });
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md px-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          {t("somethingWentWrong")}
        </h2>
        <p className="text-gray-500 mb-6 text-sm">{t("pageError")}</p>
        <button
          onClick={reset}
          className="px-4 py-2 bg-[#ff8086] text-white rounded-xl text-sm font-medium hover:opacity-90 transition-opacity"
        >
          {t("tryAgain")}
        </button>
      </div>
    </div>
  );
}
